.progress {
  background-color: var(--dds-color-surface-medium);
  border: 1px solid var(--dds-color-border-default);
  border-radius: var(--dds-border-radius-surface);
}

.fill {
  background-color: var(--dds-color-surface-action-resting);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      width var(--dds-motion-surface),
      background-color var(--dds-motion-micro-state);
  }
}

.fill--done {
  background-color: var(--dds-color-surface-success-strong);
}

.fill--error {
  background-color: var(--dds-color-surface-action-danger-resting);
}

.fill--indeterminate {
  animation: indeterminate 2s infinite linear;
}

@keyframes indeterminate {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(300%);
  }
  100% {
    transform: translateX(0);
  }
}
